import { rpc } from "@/client/rpc";
import type { CartItem } from "@/services/cartRepository";

export interface CartActionResult {
  cartId?: string;
  items: CartItem[];
  count: number;
  total: number;
  error?: string;
}

export const getCartAction = () => rpc<CartItem[]>("getCart");
export const getCartSummaryAction = () => rpc<{ count: number; total: number }>("getCartSummary");
export const addToCartAction = (productId: string, quantity = 1) =>
  rpc<CartActionResult>("addToCart", [productId, quantity]);
export const updateCartQuantityAction = (productId: string, quantity: number) =>
  rpc<CartActionResult>("updateCartQuantity", [productId, quantity]);
export const removeFromCartAction = (productId: string) =>
  rpc<CartActionResult>("removeFromCart", [productId]);
export const clearCartAction = () => rpc<CartActionResult>("clearCart");
